const feedbackSuccess = document.querySelector(".form-feedback--success"); 
const feedbackFailure = document.querySelector(".form-feedback--fail"); 
const form = document.querySelector('.form');
const FEEDBACK_EMAIL_STATUS_CLASS = "form-feedback--show"

function showSuccessMessage(){
    feedbackSuccess.classList.add(FEEDBACK_EMAIL_STATUS_CLASS);
}

function showFailureMessage(){
    feedbackFailure.classList.add(FEEDBACK_EMAIL_STATUS_CLASS);
}

function sendEmail(){
    // const formData = new FormData(form);

    const data = new URLSearchParams();
    for (const pair of new FormData(form)) {
        data.append(pair[0], pair[1]);
    }
    // formData.get("name") -> "Firstname Lastname"
    // formData.get("email") -> "user@mail.com"
    // formData.get("subject") -> "test"
    // formData.get("emailtext") -> "lorem ipsum"

    fetch('https://0gdx4ld7l8.execute-api.ap-east-1.amazonaws.com/api/email', {
        method: 'POST',
        body: data
    })
    .then(response => response.json())
    .then(result => {
        console.log("RESULT", result);
        showSuccessMessage();
        form.reset();
    })
    .catch(error => {
        console.log("ERROR", error);
        showFailureMessage();
    });
}

// Only do things on submit
form.addEventListener('submit', function(event){
    event.preventDefault();
    sendEmail();
});
// setInterval(() => {
//     feedbackSuccess.classList.toggle("form-feedback--show");
// }, 2000);